export default {
  GOOGLE_ANALYTICS_INSTRUCTIONS_URL: 'https://support.google.com/analytics/answer/9304153',
  GOOGLE_SEARCH_CONSOLE_INSTRUCTIONS_URL: 'https://support.google.com/webmasters/answer/9008080',
  GOOGLE_OWNERSHIP_VERIFICATION_URL: 'https://search.google.com/search-console/ownership',
  COOKIEBOT_SIGNUP_URL: 'https://manage.cookiebot.com/goto/signup?rid=LOZSA',
  COOKIEBOT_INSTRUCTIONS_URL:
    'https://support.cookiebot.com/hc/en-us/articles/360003734993-How-do-I-cancel-my-subscription-',
};
